// src/components/DriveGallery.tsx
import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Loader from "./Loader";

const BACKEND_URL = "https://nepprepbbalschedules.vercel.app"; // Update this
//const BACKEND_URL = "http://localhost:3000";

const DriveGallery = () => {
  const [folders, setFolders] = useState([]);
  const queryParams = new URLSearchParams(window.location.search);
  const isEmbedded = queryParams.get("isEmbedded") === "true";
  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [loadedImages, setLoadedImages] = useState({});

  const handleImageLoad = (id) => {
    setLoadedImages((prev) => ({ ...prev, [id]: true }));
  };

  useEffect(() => {
    setLoading(true);
    fetch(`${BACKEND_URL}/schedule-folders/1RseYO4MPdshT8kkEEw3ETypqXkGyQAyC`)
      .then((res) => res.json())
      .then((data) => setFolders(data))
      .catch((err) => console.error("Error loading folders", err))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (selectedImage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [selectedImage]);

  useEffect(() => {
    if (selectedImage && isEmbedded) {
      window.scrollTo(0, 0);
    }
  }, [selectedImage, isEmbedded]);

  const cleanName = (name) => name.replace(/^\d{1,2}-/, "").trim();

  return (
    <div
      style={
        isEmbedded
          ? { padding: "40px 0" }
          : {
              backgroundImage:
                "url('https://storage.mobilebuilder.net/users/images/082b4b3c-600a-4f18-85f5-e970fa96a50e.jpeg')",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              padding: "40px 0",
            }
      }
    >
      <div
        style={
          isEmbedded
            ? {}
            : {
                background:
                  "linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.8))",
              }
        }
      >
        <h2
          style={{
            textAlign: "left",
            padding: "40px 0",
            borderBottom: "1px solid #999",
            margin: "0 20px",
          }}
        >
          Practice and Events Schedule
        </h2>
        {loading ? (
          <div
            style={{
              maxWidth: "600px",
              margin: "0 auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center", // optional, if you want vertical centering
              height: "200px", // optional height for vertical alignment
            }}
          >
            <Loader />
          </div>
        ) : (
          <>
            {folders.map((folder, index) => (
              <div
                key={index}
                style={{ marginBottom: "50px", borderBottom: "1px solid #999" }}
              >
                <h2>{cleanName(folder.name)}</h2>
                <Carousel
                  showThumbs={true}
                  showArrows={true}
                  infiniteLoop
                  autoPlay={false}
                  showStatus={false}
                  dynamicHeight
                  axis="horizontal"
                  thumbWidth={100}
                  onClickItem={(index) =>
                    setSelectedImage(folder.files[index].fullResUrl)
                  }
                >
                  {folder.files.map((file) => (
                    <div
                      key={file.id}
                      style={{ position: "relative", minHeight: "300px" }}
                    >
                      {!loadedImages[file.id] && (
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 1,
                          }}
                        >
                          <Loader />
                        </div>
                      )}
                      <img
                        src={file.fullResUrl}
                        alt={file.name}
                        style={{
                          maxWidth: "1000px",
                          objectFit: "contain",
                          opacity: loadedImages[file.id] ? 1 : 0,
                          transition: "opacity 0.3s ease-in-out",
                        }}
                        onLoad={() => handleImageLoad(file.id)}
                      />
                    </div>
                  ))}
                </Carousel>
                {selectedImage && (
                  <div
                    onClick={() => setSelectedImage(null)}
                    style={{
                      position: "fixed",
                      top: isEmbedded ? "0" : "0px",
                      left: "0",
                      width: "100vw",
                      height: "100vh",
                      backgroundColor: "rgba(0, 0, 0, 0.85)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 9999,
                      cursor: "zoom-out",
                      overflow: "hidden",
                      margin: 0, //  important in embedded mode
                      padding: 0,
                    }}
                  >
                    <img
                      src={selectedImage}
                      alt="Zoomed"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                )}
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default DriveGallery;
